import CssBaseline from "@mui/material/CssBaseline"
import ThemeProvider from "@mui/material/styles/ThemeProvider"
import Container from "@mui/material/Container"
import Grid from "@mui/material/Grid"

import { DEFAULT_THEME } from "helpers/utils/constants"
import { getTheme } from "styles/themes"
import ResultCard from "widgets/common/ResultCard"

/**
 * Fallback for the root error boundary. The boundary sits above App, so this
 * brings its own theme, and it stays clear of the router and of i18n: the
 * locales load as their own chunks and are part of what can be broken here.
 */
export default function AppErrorFallback() {
  return (
    <ThemeProvider theme={getTheme(DEFAULT_THEME)}>
      <CssBaseline />
      <Container>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
          sx={{ mt: "13vh" }}
        >
          <ResultCard
            type="error"
            text="Something went wrong. Reloading the page usually fixes it."
            button="Reload"
            onClick={() => window.location.reload()}
          />
        </Grid>
      </Container>
    </ThemeProvider>
  )
}
